import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <MediaSection />
        <AboutSection />
        <CarouselSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
        <CardsSection />
        <TopicsSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}